import styled from 'styled-components';
import { Row } from '@packages/utils';

export const SSidebarFooterMenuWrapper = styled(Row)`
  padding: 0 8px;
  width: 100%;
`;
